<ng-template #tpl>
	<ng-container *transloco="let translate">
		<ng-template #footerBtnHiddenContentTpl></ng-template>

		<ng-container *clientScreen="let isDesktop = isDesktop">
			@if (
				{
					slides: slides$ | async,
					slideIdx: slideIdx$ | async,
					activeId: activeId$ | async,
					indicatorIndex: indicatorIndex$ | async,
				};
				as vm
			) {
				@if (vm.slides?.[vm.slideIdx ?? -1]; as activeSlide) {
					<info-modal-cdk [closing]="closing" (outsideClick)="outsideClick(activeSlide)">
						<carousel-container
							#carousel
							class="h-100"
							(activeSlideChange)="onActiveSlideChange($event)"
						>
							<carousel-slides-wrapper>
								@for (slide of slides$ | async; track trackByI18n($index, slide)) {
									<carousel-slide [slideId]="slide.i18n">
										<info-modals-slide
											[videoId]="slide.videoId"
											(tutorialOpened)="done('tutorial-clicked')"
										>
											<img
												[src]="slideImageSrc(slide.imageName)"
												draggable="false"
											/>
											<ng-container ngProjectAs="[title]">
												<span
													[innerHTML]="
														translate(slide | slideTitle: i18nName)
													"
												></span>
											</ng-container>
											<span
												[innerHTML]="
													translate(slide | slideMessage: i18nName)
												"
											></span>
										</info-modals-slide>
									</carousel-slide>
								}
							</carousel-slides-wrapper>
						</carousel-container>
						<div ngProjectAs="[footer]" class="w-100 fl fl-ai-c fl-jc-c">
							@if (isDesktop) {
								<div class="fl-adaptable">
									<div
										class="fl fs-m fc-primary p-3 border-box"
										style="line-height: 1em; margin-left: auto"
									>
										<div sameWidthText>
											@if ((vm.indicatorIndex ?? 0) > 0) {
												<button
													sameWidthTextItem="visible"
													class="fl"
													(click)="goBack(carousel)"
												>
													<i
														class="icon-chevron-large chevron-left fs-em"
														style="margin-right: 4px"
													></i>
													{{ translate('infoModals.general.back') }}
												</button>
											}
											<div sameWidthTextItem="hidden" class="fl">
												<i
													class="icon-chevron-large chevron-left fs-em"
													style="margin-right: 4px"
												></i>
												{{ translate('infoModals.general.back') }}
											</div>
										</div>
									</div>
								</div>
							}
							<div class="fl-fixed">
								@if (showIndicator$ | async) {
									<carousel-instagram-dots
										ngProjectAs="[footer]"
										class="slider-indicator p-3-l border-box"
										[maxActiveCount]="count$ | async"
										[count]="count$ | async"
										[index]="vm.indicatorIndex"
									></carousel-instagram-dots>
								}
							</div>
							<div class="fl-adaptable fl fl-ai-c fl-jc-fe">
								<div
									class="fl fs-m fc-primary p-3 border-box"
									style="line-height: 1em; margin-left: auto"
								>
									@if (isLastSlide$ | async) {
										<button class="fl" (click)="done('done')">
											{{
												translate(activeSlide | slideFooter: i18nName)
													| slideFooterFallback
														: activeSlide
														: i18nName
														: translate('infoModals.general.done')
											}}
										</button>
									} @else {
										<button class="fl" (click)="goNext(carousel)">
											{{
												translate(activeSlide | slideFooter: i18nName)
													| slideFooterFallback
														: activeSlide
														: i18nName
														: translate('infoModals.general.next')
											}}
											<i
												class="icon-chevron-large chevron-right fs-em"
												style="margin-left: 4px"
											></i>
										</button>
									}
								</div>
							</div>
						</div>
						@if (activeSlide.showCross ?? true) {
							<button
								ngProjectAs="[insideModal]"
								class="pos-abs pos-t-0 pos-r-0 fl p-2"
								(click)="done('cross')"
							>
								<i class="icon-cross fc-400"></i>
							</button>
						}
					</info-modal-cdk>
					<ng-template #nextBtnTpl>
						<button class="fl" (click)="goNext(carousel)">
							{{
								translate(activeSlide | slideFooter: i18nName)
									| slideFooterFallback
										: activeSlide
										: i18nName
										: translate('infoModals.general.next')
							}}
							<i
								class="icon-chevron-large chevron-right fs-em"
								style="margin-left: 4px"
							></i>
						</button>
					</ng-template>
				}
			}
		</ng-container>
	</ng-container>
</ng-template>
